import React, { useEffect, useState } from 'react';

import { Header, Button } from '../components';
import {
  AgentName, AgentNameMaster, dropdownDataColumn, dropdownDataReviewPeriodStart, dropdownDataReviewPeriodEnd,
  dropdownDataTokenizerTypes, dropdownTransferLearning, dropdownDataColumnSpellChecked,
  dropdownTransferLearningIntent,
} from '../data/dummy';
import { useStateContext } from '../contexts/ContextProvider';
import AgentComment from '../components/AgentComment';
import AgentCommentMaster from '../components/AgentCommentMaster';
import { useLocation, useNavigate } from "react-router-dom";

import Dropdown from '../components/Dropdown';
import DataPreview from '../components/DataPreview';
import Progressbar from '../components/Charts/Progressbar';

import ModelPerformance from '../components/ModelPerformance';
import ModelParameterList from '../components/ModelParameterList';
import TransferLearningDataset from '../components/TransferLearningDataset';
import axios from 'axios';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import Swal from 'sweetalert2';
import { handleAwaitingPromise } from '../../node_modules/sweetalert2/src/instanceMethods/close';

const AImodeling = () => {
  const navigate = useNavigate();
  const [isRequestSent, setIsRequestSent] = useState(false); // 요청 제어를 위한 상태 추가
  const [lambdaResult, setLambdaResult] = useState("AI 분류를 위한 자동 모델링 중입니다 조금만 기다려주세요...");
  const [loadingClassification, setLoadingClassification] = useState(false);
  const [loadingComplete, setLoadingComplete] = useState(false);
  const [selectedValueSpellCheckCol, setSelectedValueSpellCheckCol] = useState('');
  const [selectedValueModelingCol, setSelectedValueModelingCol] = useState('');
  const [selectedValueTLdataset, setSelectedValueTLdataset] = useState('');

  const [spellCheckColumn, setSpellCheckColumn] = useState('');
  const [modelingColumn, setModelingColumn] = useState('');
  const [transferLearningDataset, setTransferLearningDataset] = useState('');

  const { currentColor, currentMode } = useStateContext();
  const [isTrainModelStarted, setIsTrainModelStarted] = useState(false);
  const [isTrainModelCompleted, setIsTrainModelCompleted] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [progress, setProgress] = useState(0);
  const [progressStatus, setProgressStatus] = useState("학습이 완료되면 최적화된 모델별 성능과 하이퍼파라미터를 확인하실 수 있어요 :)");
  const [userId, setUserId] = useState('');
  const [unixTime, setUnixTime] = useState('');
  
  const currentUrl = window.location.href;
  let AItype = "";
  let AItypeName = "";
  let nextPage = "";
  let dropdownModelingColumn = dropdownDataColumn;
  const [previewType, setPreviewType] = useState("raw");
  let dropdownTransferLearningData = "";

  // 감정분류or의도분류에 따라 데이터셋 다르게 부여
  if (currentUrl.includes('cls/sentiment')) {
    AItype = "classifiedSentiment";
    AItypeName = "감정분류";
    nextPage = '/cls/sentiment/result';
    dropdownTransferLearningData = dropdownTransferLearning;
  } else if (currentUrl.includes('cls/intent')) {
    AItype = "classifiedIntent";
    AItypeName = "토픽분류";
    nextPage = '/cls/intent/result';
    dropdownTransferLearningData = dropdownTransferLearningIntent;
  } else if (currentUrl.includes('cls/total')) {
    AItype = "classifiedTotal";
  };

  const modelList = ["KoGPT", "KoELECTRA", "KoBERT", "KLUE-BERT", "KcBERT"];
  const [isSpellChecked, setIsSpellChecked] = useState(false);
  const handleSpellCheck = () =>{
    console.log(`spellCheckColumn: ${spellCheckColumn}`);
    if (spellCheckColumn){
      Swal.fire({
        title: '맞춤법 교정 시작',
        html: "새로고침하지 마시고 잠시만 기다려주세요.<br/>최대 30초까지 소요될 수 있어요 :)",
        icon: 'info',
        timer: 7000,
        allowOutsideClick: false, // 팝업 밖을 클릭해도 닫히지 않음
        allowEscapeKey: false,    // ESC 키로 닫을 수 없게 설정
        allowEnterKey: false,     // 엔터 키로 닫을 수 없게 설정
        timerProgressBar: true,   // 타이머 진행 상황 표시
        didOpen: () => {
            Swal.showLoading();     // 팝업에 로딩 애니메이션 표시
        },
        willClose: () => {
          Swal.fire({
            title: `맞춤법 교정 완료`,
            icon: 'success',
            confirmButtonText: '확인',
            confirmButtonColor: currentColor,
          })
          setIsSpellChecked(true);
          setPreviewType("spellchecked")
          // ysjeon | dropdownVisualizingColumn 변수 정의 필요 - 임시 주석 처리
          // dropdownVisualizingColumn = dropdownDataColumnSpellChecked;
        }
    })
    } else {
      Swal.fire({
        title: '컬럼을 먼저 선택해 주세요',
        icon: 'warning',
        confirmButtonText: '확인',
        confirmButtonColor: currentColor,
        didOpen: () => {
          Swal.hideLoading(); // 혹시 이전에 로딩이 있었다면 명시적으로 로딩 숨기기
      }
      });
    }
    
  }

  const handleProgressBar = () => {

    if (!modelingColumn){
      Swal.fire({
        html: `상단에서 텍스트 분류 모델링할 컬럼을 먼저 선택해 주세요`,
        icon: 'warning',
        confirmButtonText: '확인',
        confirmButtonColor: currentColor,
        didOpen: () => {
          Swal.hideLoading(); // 혹시 이전에 로딩이 있었다면 명시적으로 로딩 숨기기
      }
      });
      return;
    }

    if (!transferLearningDataset){
      Swal.fire({
        html: `전이학습용 데이터셋을 먼저 선택해 주세요`,
        icon: 'warning',
        confirmButtonText: '확인',
        confirmButtonColor: currentColor,
        didOpen: () => {
          Swal.hideLoading(); // 혹시 이전에 로딩이 있었다면 명시적으로 로딩 숨기기
      }
      });
      return;
    }

    Swal.fire({
      title: `분류모델 학습시작`,
      html: "새로고침하지 마시고 잠시만 기다려주세요.<br/>최대 30초까지 소요될 수 있어요 :)",
      icon: 'info',
      confirmButtonText: '확인',
      confirmButtonColor: currentColor,
      didOpen: () => {
        Swal.hideLoading(); // 혹시 이전에 로딩이 있었다면 명시적으로 로딩 숨기기
    }
    });
    setIsTrainModelCompleted(false);
    setIsTrainModelStarted(true);
    setShowSpinner(true);
    return;
  };

  const handleTrainReset = () => {
    Swal.fire({
      title: '모델 학습을 리셋하였습니다.',
      icon: 'info',
      confirmButtonText: '확인',
      confirmButtonColor: currentColor,

    });
    setIsTrainModelCompleted(false);
    setIsTrainModelStarted(false);
    setShowSpinner(false);
    setProgress(0);
    setProgressStatus("학습이 완료되면 최적화된 모델별 성능과 하이퍼파라미터를 확인하실 수 있어요 :)");
    return;
  };

  const handleSpellCheckColumn = (selectedValueSpellCheckCol) => {
    setSpellCheckColumn(selectedValueSpellCheckCol); // Dropdown 선택 값 업데이트
  }

  const handleModelingColumn = (selectedValueModelingCol) => {
    setModelingColumn(selectedValueModelingCol); // Dropdown 선택 값 업데이트
  }

  const handleTLdataset = (selectedValueTLdataset) => {
    setTransferLearningDataset(selectedValueTLdataset); // Dropdown 선택 값 업데이트
  }

  useEffect(() => {

    const storedUserID = localStorage.getItem('userId');
    setUserId(storedUserID || '');
    console.log(`storedUserID: ${storedUserID}`);

    const storedUnixTime = localStorage.getItem('unixTime');
    setUnixTime(storedUnixTime || '');
    console.log(`storedUnixTime: ${storedUnixTime}`);

    if (isTrainModelStarted) {
      console.log("학습시작")

      const interval = setInterval(() => {
        setProgress(prev => {
          // const nextProgress = prev + 5;
          // 1에서 6까지의 랜덤한 값으로 progress 증가
          const randomIncrement = Math.floor(Math.random() * 6) + 1;
          const nextProgress = prev + randomIncrement;
          if (nextProgress < 12) {
            setProgressStatus("사전학습된 토크나이저 로드 중...");
          } else if (12 <= nextProgress && nextProgress < 30) {
            setProgressStatus("모델 맞춤 토큰화 진행 중 ...");
          } else if (30 <= nextProgress && nextProgress < 70) {
            setProgressStatus("사전학습된 감정분류 모델 로드 중 ...");
          } else if (70 <= nextProgress && nextProgress < 90) {
            setProgressStatus("전이학습 위한 파라미터 튜닝 중 ...");
          } else if (90 <= nextProgress && nextProgress < 100) {
            setProgressStatus("최적화된 모델 성능 평가 중 ...");
          } else if (100 <= nextProgress) {
            setProgressStatus("분류모델 전이학습 완료!");
          }


          if (nextProgress >= 100) {
            setShowSpinner(false);
            setIsTrainModelStarted(false);
            setShowSpinner(false);
            setIsTrainModelCompleted(true);
            handleLambdaRequest();
            Swal.fire({
              title: `모델학습 완료`,
              html : `성능 지표 확인 후 모델을 선택해 주세요 :)`,
              icon: 'success',
              confirmButtonText: '확인',
              confirmButtonColor: currentColor,
              didOpen: () => {
                Swal.hideLoading(); // 혹시 이전에 로딩이 있었다면 명시적으로 로딩 숨기기
            }
            });
            return 100;
          } else {
            return nextProgress;
          }


          // return nextProgress >= 100 ? 100 : nextProgress; // 100%를 초과하지 않도록 설정
        });
      }, 1500); // 1.5초마다 업데이트

      return () => clearInterval(interval);
    }

  //   if (loadingClassification) {
  //     const maxWaitTime = 20000; // 최대 대기 시간
  //     const start = Date.now();

  //     const checkLoadingStatus = () => {
  //         const elapsed = Date.now() - start;

  //         if (elapsed >= maxWaitTime) {
  //             setLoadingClassification(false);
  //             setLoadingComplete(true);
  //         } else {
  //             setTimeout(checkLoadingStatus, 100); // 0.1초마다 상태 확인
  //         }
  //     };

  //     checkLoadingStatus();

  //     return () => clearTimeout(checkLoadingStatus); // 컴포넌트 unmount 시 타이머 정리
  // }


  }, [previewType, isTrainModelStarted]);

  const handleClassification = () => {
    setLoadingClassification(true);
    
    Swal.fire({
      title: `${AItypeName} 시작`,
      html: "새로고침하지 마시고 잠시만 기다려주세요.<br/>최대 30초까지 소요될 수 있어요 :)",
      icon: 'info',
      timer: 20000,
      allowOutsideClick: false, // 팝업 밖을 클릭해도 닫히지 않음
      allowEscapeKey: false,    // ESC 키로 닫을 수 없게 설정
      allowEnterKey: false,     // 엔터 키로 닫을 수 없게 설정
      timerProgressBar: true,   // 타이머 진행 상황 표시
      didOpen: () => {
          Swal.showLoading();     // 팝업에 로딩 애니메이션 표시
      },
      willClose: () => {
        Swal.fire({
          title: `${AItypeName} 완료`,
          html: "확인 버튼을 누르시면 결과 페이지로 이동해요",
          icon: 'success',
          allowOutsideClick: false, // 팝업 밖을 클릭해도 닫히지 않음
          allowEscapeKey: false,    // ESC 키로 닫을 수 없게 설정
          allowEnterKey: false,     // 엔터 키로 닫을 수 없게 설정
          confirmButtonText: '확인',
          confirmButtonColor: currentColor,
        }).then((result) => {
          if (result.isConfirmed) {
            navigate(nextPage);
          }
          });
      }
  })
}

  const handleLambdaRequest = async () => {
    if (isRequestSent) return;
    setIsRequestSent(true); // 요청 보냄 상태로 설정

    const sentimentModelScore = "[['metric', 'koGPT', 'koBERT', 'kcBERT', 'KlueBERT', 'KoELECTRA'],['Accuracy', '89.5%', '90.2%', '91.0%', '89.8%', '91.5%'],['F1', '88.2%', '89.4%', '90.1%', '89.0%', '91.2%'],['Precision', '87.5%', '89.0%', '90.3%', '88.7%', '90.8%'],['Recall', '89.0%', '90.0%', '90.0%', '89.5%', '91.0%'],['AUC-ROC', '92.1%', '93.0%', '93.5%', '92.8%', '94.0%'],['AUC-PR', '91.0%', '92.3%', '92.8%', '91.5%', '93.2%'],['Cohen's Kappa', '0.77', '0.79', '0.81', '0.78', '0.82'],['MCC', '0.76', '0.78', '0.80', '0.77', '0.81']]"
    const intentModelScore = "[['metric', 'koGPT', 'koBERT', 'kcBERT', 'KlueBERT', 'KoELECTRA'],['Accuracy', '89.5%', '90.2%', '91.0%', '89.8%', '91.5%'],['F1', '88.2%', '89.4%', '90.1%', '89.0%', '91.2%'],['Precision', '87.5%', '89.0%', '90.3%', '88.7%', '90.8%'],['Recall', '89.0%', '90.0%', '90.0%', '89.5%', '91.0%'],['AUC-ROC', '92.1%', '93.0%', '93.5%', '92.8%', '94.0%'],['AUC-PR', '91.0%', '92.3%', '92.8%', '91.5%', '93.2%'],['Cohen's Kappa', '0.77', '0.79', '0.81', '0.78', '0.82'],['MCC', '0.76', '0.78', '0.80', '0.77', '0.81']]"
    try {
      let requestData;
      if (AItype === "classifiedSentiment") {
        requestData = {
          name: "llm_ai_1",
          dataset: "핀테크 App Review 감정분류 v1.1.4",
          sentiment_model_score: sentimentModelScore,
        };
      } else if (AItype === "classifiedIntent") {
        requestData = {
          name: "llm_ai_3",
          dataset: "핀테크 App Review 의도분류 v1.0.0",
          intent_model_score: intentModelScore,
        };
      } else {
        console.error("Invalid AItype value:", AItype);
        setLambdaResult("AI 유형이 잘못되었습니다.");
        return;
      }

      const response = await axios.post(
        "https://farqijyj9a.execute-api.ap-northeast-2.amazonaws.com/241113/agent",
        requestData
      );

      // 요청 데이터 출력
      console.log("요청 데이터:", requestData);

      // Lambda 응답 디코딩 및 처리
      const responseBody = JSON.parse(response.data.body); // `body`를 JSON으로 파싱
      console.log("Lambda 응답:", responseBody);
      // alert(`감정분류를 위한 모델링이 완료되었습니다. 데몽이의 조언과 함께 결과를 확인해주세요!`);
      // Lambda 결과값 반영
      setLambdaResult(responseBody.answer || "결과를 불러왔습니다.");
    } catch (error) {
      console.error("Lambda 호출 중 오류 발생:", error);
      setLambdaResult("오류가 발생했습니다. 다시 시도해주세요.");
      setIsRequestSent(true); // 실패 시에도 재시도 안함.
    }
  };

  return (
    <div>
      <div className="m-2 md:m-5 mt-0 p-2 md:p-5 bg-white rounded-3xl">
        <Header category={AItypeName} title="AI 모델링" />
        <AgentComment title={AgentName} comment={`${AItypeName}를 시작하기 전에 먼저 맞춤법을 교정해 데이터 품질을 높여보세요. 그다음, 데이터가 적을 경우 전이 학습이 효과적이니, 제공되는 다양한 모델을 테스트해 가장 적합한 모델을 선택해보세요. 저는 전이학습 후 최종 모델 선택에 도움을 드리기 위해 맨 아래에 대기하고 있을게요!`}></AgentComment><br />
      </div>
      <div className="m-2 md:m-5 mt-0 p-2 md:p-5 bg-white rounded-3xl">
      <Header title="맞춤법 교정하기" />

        <div className="flex gap-5 items-center">
          <div className="flex gap-3 items-center">
            <p className="text-xl font-semibold">조회기간</p>
            <p className="text-s">시작일</p>
            <Dropdown currentMode={currentMode} dropdownData={dropdownDataReviewPeriodStart} />
            <p className="text-s">종료일</p>
            <Dropdown currentMode={currentMode} dropdownData={dropdownDataReviewPeriodEnd} />
          </div>
          <div className="flex gap-3 items-center">
            <p className="text-xl font-semibold">맞춤법 교정 컬럼 선택</p>
            <Dropdown currentMode={currentMode} 
                      dropdownData={dropdownDataColumn}
                      selectedValue={selectedValueSpellCheckCol} // 선택된 값 전달
                      onChange={handleSpellCheckColumn} // 선택 값 변경 핸들러

                       />

            <Button
              color="white"
              bgColor={currentColor}
              text="맞춤법 교정하기"
              borderRadius="10px"
              onClick={() => handleSpellCheck()}
            />


          </div>
          <div className="flex gap-3 items-center">
            <p className="text-xl font-semibold">{AItypeName} 컬럼 선택</p>
            {isSpellChecked 
            ?
            <Dropdown currentMode={currentMode}
                      dropdownData={dropdownDataColumnSpellChecked}
                      selectedValue={dropdownDataColumnSpellChecked} // 선택된 값 전달
                      onChange={handleModelingColumn} // 선택 값 변경 핸들러
                       />
             :
             <Dropdown currentMode={currentMode}
             dropdownData={dropdownDataColumn}
             selectedValue={dropdownDataColumnSpellChecked} // 선택된 값 전달
             onChange={handleModelingColumn} // 선택 값 변경 핸들러
              />

             }
            
          </div>
        </div>
        <br />

        {isSpellChecked
        ?
        <DataPreview previewType={"spellchecked"}></DataPreview>
        :
        <DataPreview previewType={"raw"}></DataPreview>
        }
        
        
          
        
        <br />
      </div>
      <div className="m-2 md:m-5 mt-0 p-2 md:p-5 bg-white rounded-3xl items-center">
      <Header title="학습모델 전이학습" />
        <div className="flex gap-3 items-center">
          <div className="flex gap-3 items-center">
            <p className="text-xl font-semibold">전이학습 Dataset 선택</p>
            <Dropdown currentMode={currentMode}
                      dropdownData={dropdownTransferLearningData}
                      selectedValue={selectedValueTLdataset} // 선택된 값 전달
                      onChange={handleTLdataset} // 선택 값 변경 핸들러

            />
          </div>
          <p className="text-xl font-semibold items-center">언어모델(LM) 선택</p>
          <div className="flex gap-3 items-center">
            {modelList.map((modelName, index) => (
              <label key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                <input
                  type="checkbox"
                  checked={true}
                  onChange={null}
                  style={{ marginRight: '8px' }}
                />
                {modelName}
              </label>
            ))}
          </div>
          <div className="flex gap-1 items-center">

            <Button
              color="white"
              bgColor={currentColor}
              text="모델학습 시작"
              borderRadius="10px"
              marginRight="10px"
              disabled={isTrainModelStarted} // 조건에 따라 비활성화
              onClick={() => {
                handleProgressBar(); // 진행 바 관련 로직 실행
              }}
            />

            <Button
              color="white"
              // bgColor={(isTrainModelStarted || isTrainModelCompleted) ? 'rgb(215, 78, 114)' : 'gray'}
              bgColor={'rgb(215, 78, 114)'}
              text="모델학습 리셋"
              borderRadius="10px"
              disabled={!(isTrainModelStarted || isTrainModelCompleted)}
              onClick={() => {
                handleTrainReset(); // 진행 바 관련 로직 실행
              }}

            />
          </div>
        </div>
        <TransferLearningDataset AItype={AItype} />
        <br />
      </div>


      {/* 컴포넌트 그룹 */}
      <div className="m-2 md:m-5 mt-0 p-2 md:p-5 bg-white rounded-3xl">
        <div className="flex gap-0.1">
          <p className="text-xl font-semibold">모델학습 진행률(%)</p>
          <div style={{
            width: '800px', marginLeft: '60px', marginRight: '20px',
            display: 'flex', alignItems: 'center'
          }}>

            <div style={{
              flex: 1, backgroundColor: '#e0e0e0',
              borderRadius: '8px', overflow: 'hidden'
            }}>
              <div
                style={{
                  width: `${progress}%`,
                  height: '20px',
                  backgroundColor: 'rgb(90, 198, 213)',
                  transition: 'width 0.5s ease-in-out',
                }}
              />
            </div>
            <span
              style={{
                marginLeft: '30px',
                marginRight: '10px',
                color: 'rgb(90, 198, 213)',
                fontWeight: 'bold',
              }}
            >
              {progress}%
            </span>
            {showSpinner && (
              <FontAwesomeIcon
                icon={faSpinner}
                spin
                size="lg"
                style={{ margin: '0 20px', color: 'rgb(90, 198, 213)' }}
              />
            )}
            <p className="text-s" style={{ marginRight: '20px', marginLeft: '20px', display: 'flex', alignItems: 'center' }}>{progressStatus}</p>

          </div>
        </div>
        <br />
      </div>

      {
        isTrainModelCompleted

          ?

          <div>
            <div className="m-2 md:m-5 mt-0 p-2 md:p-5 bg-white rounded-3xl">
              <p className="text-xl font-semibold">분류모델 성능평가</p>
              <ModelPerformance></ModelPerformance>
              <br />
            </div>

            <div className="m-2 md:m-5 mt-0 p-2 md:p-5 bg-white rounded-3xl">
              <p className="text-xl font-semibold">최적화된 하이퍼파라미터</p>
              <ModelParameterList></ModelParameterList>
              <br />
            </div>

            <div className="m-2 md:m-5 mt-0 p-2 md:p-5 bg-white rounded-3xl">
              <AgentCommentMaster title={AgentName} comment={lambdaResult}></AgentCommentMaster>
              <div className="flex justify-end">
                <div className="flex items-center gap-5">
                  <p className="text-s">최종 모델 선택</p>
                  <Dropdown currentMode={currentMode} dropdownData={dropdownDataTokenizerTypes} />
                  <Button
                    color="white"
                    bgColor={currentColor}
                    text="▶감정분류 시작하기"
                    borderRadius="10px"
                    marginRight="10px"
                    onClick={() => handleClassification()}
                  />
                </div>
              </div>
            </div>
          </div>

          :
          null
      }


    </div>
  );
};

export default AImodeling;
